(function() {
    "use strict";

    // TODO: change to attribute?
    // This would allow us to decorate any item with an info indication
    angular.module("app").directive("fodbzInfoSign", FodbzInfoDirective);

    FodbzInfoDirective.$inject = ["$timeout"];
    function FodbzInfoDirective($timeout) {
        return {
            scope: {
                fodbzInfo: '@',
            },
            template: `
                <div style="display: inline-block">
                    <span title="{{fodbzInfo}}"
                          data-toggle="tooltip"
                          data-placement="bottom"
                          class="info-button">
                        <i class="fa fa-info"></i>
                    </span>
                </div>`,
            link: function () {
                initialize();

                function initialize() {
                    $timeout(() => $("[data-toggle='tooltip'").tooltip(), 0);
                }
            }
        };
    }
})();